import { render, staticRenderFns } from "./A7Dashboard.vue?vue&type=template&id=8640a198&scoped=true&"
import script from "./A7Dashboard.vue?vue&type=script&lang=js&"
export * from "./A7Dashboard.vue?vue&type=script&lang=js&"
import style0 from "./A7Dashboard.vue?vue&type=style&index=0&id=8640a198&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8640a198",
  null
  
)

export default component.exports